export default __webpack_public_path__ + "static/media/theme_eventyr.36acb42c.jpg";